<div class="acs-page">
  <!-- Page Header -->
  <div class="acs-page-header">
    <div class="acs-page-header__title-section">
      <h1 class="acs-page-header__title">
        🔐 Impersonation Audit Logs
      </h1>
      <p class="acs-page-header__subtitle">
        Monitor and manage impersonation sessions for security compliance
      </p>
      <div class="acs-page-header__stats">
        <span class="acs-stat-pill acs-stat-pill--active">
          🟢 {{ activeSessions.length }} Active
        </span>
        <span class="acs-stat-pill acs-stat-pill--total">
          📋 {{ auditLogs.length }} Total Sessions
        </span>
      </div>
    </div>
  </div>

  <!-- Active Sessions Section -->
  <div class="acs-section active-sessions-section" [class.acs-section--collapsed]="activeSessions.length === 0 && !loadingActiveSessions">
    <div class="acs-section__header">
      <h2 class="acs-section__title">
        🟢 Active Impersonation Sessions
        <span class="acs-section__badge" *ngIf="activeSessions.length > 0">
          {{ activeSessions.length }}
        </span>
      </h2>
      <p class="acs-section__description">
        Currently active impersonation sessions. End sessions that are no longer needed.
      </p>
    </div>

    <!-- Compact empty state -->
    <div *ngIf="activeSessions.length === 0 && !loadingActiveSessions" class="acs-section__empty-compact">
      <div class="acs-empty-compact">
        <span class="acs-empty-compact__icon">✓</span>
        <span class="acs-empty-compact__text">No active sessions - All clear!</span>
      </div>
    </div>

    <!-- Full grid for active sessions -->
    <div *ngIf="activeSessions.length > 0 || loadingActiveSessions" class="acs-section__content">
      <acs-data-grid
        *ngIf="!loadingActiveSessions"
        [data]="activeSessions"
        [columns]="activeSessionColumns"
        [loading]="loadingActiveSessions"
        [searchable]="true"
        [sortable]="true"
        [enableDropdownFilters]="false"
        [showPagination]="true"
        [pageSize]="10"
        searchPlaceholder="Search active sessions..."
        emptyMessage="No active impersonation sessions found. All sessions have ended or expired.">
      </acs-data-grid>

      <!-- Loading state for active sessions -->
      <div *ngIf="loadingActiveSessions" class="acs-loading-container">
        <acs-loading-spinner message="Loading active sessions..."></acs-loading-spinner>
      </div>
    </div>
  </div>

  <!-- Historical Audit Logs Section -->
  <div class="acs-section audit-logs-section">
    <div class="acs-section__header">
      <h2 class="acs-section__title">
        📋 Historical Audit Logs
        <span class="acs-section__badge" *ngIf="auditLogs.length > 0">
          {{ auditLogs.length }}
        </span>
      </h2>
      <p class="acs-section__description">
        Complete audit trail of all impersonation sessions showing start time, end time, duration, and status for each session.
      </p>
    </div>

    <div class="acs-section__content">
      <acs-data-grid
        *ngIf="!loadingLogs"
        [data]="auditLogs"
        [columns]="auditLogColumns"
        [loading]="loadingLogs"
        [searchable]="true"
        [sortable]="true"
        [enableDropdownFilters]="true"
        [showPagination]="true"
        [pageSize]="20"
        searchPlaceholder="Search audit logs..."
        emptyMessage="No audit logs found. Impersonation activities will appear here once they occur.">
      </acs-data-grid>

      <!-- Loading state for audit logs -->
      <div *ngIf="loadingLogs" class="acs-loading-container">
        <acs-loading-spinner message="Loading audit logs..."></acs-loading-spinner>
      </div>
    </div>
  </div>
</div>
